import { graphql } from '@/client/services/api/graphql/gql';

export const adminMessagingListQuery = graphql(`
  query AdminAppAnnouncements($page: Int, $perPage: Int, $published: Boolean) {
    appAnnouncements(page: $page, perPage: $perPage, published: $published) {
      items {
        id
        title
        content
        routes
        published
        publishedAt
        createdAt
        createdBy {
          id
          fullName
        }
      }
      totalCount
    }
  }
`);
